// extracted by mini-css-extract-plugin
module.exports = {"heading":"Title_heading__UG4zy","big":"Title_big__kqljV"};